import {
  Dimensions,
  Platform, 
} from 'react-native';

import { bf } from './bf';

global.c = null; // current component, replaced at cf.myRN_stt, cleared at cf.myNV_stt_move

export class ic { // individual constant
  //
  static g_os = 
    (Platform.OS == 'android') ?
      'a'
    : (Platform.OS == 'ios') ?
      'i'
    : (Platform.OS == 'web') ?
      'w'
    : ''
  ;

  //
  static g_app_name = 'mqcs';
  static g_app_type = ['w', 'i', 'a']; // w: web, i:ios, a:android
  //
  static g_ver = '1.0.6';

  static gb_dbg = true; // 開発環境
  //static gb_dbg = false; // 本番環境
  //
  static gb_dev = false; // 本番環境
  //    
//  static g_url0 = 'http://localhost:19006'; 
//  static g_url0 = 'http://mqcs2.data-harness.com'; 
//  static g_url1 = 'http://mqcs.data-harness.com/callback'; // for db nginx の conf を変更要
//  static g_url2 = 'http://mqcs.data-harness.com/static'; // for file
  static g_url1 = 'https://mqcsb.mymemo-navi.com/callback'; // for db nginx の conf を変更要
  static g_url2 = 'https://mqcsb.mymemo-navi.com/static'; // for file

  //
  static g_srt_key = '1kam1lfG{}2iGRfBaA'.f(ic.g_app_name); // secret key
  //    
  static gn_w = Dimensions.get('window').width - 2; // windows の web において horizontal scroll bar を表示しないために -2 が必要
  static gn_h = Dimensions.get('window').height;

  static gn_maxBdyW = 1024; // ipad pro 12.9 を考慮
  static gn_minBdyW = 375; // ipad pro 12.9 を考慮

//  static gn_bdyW = (Dimensions.get('window').width <= 1024) ? Dimensions.get('window').width : 1024; // ipad pro 12.9 を考慮
  static gn_bdyW = (ic.gn_w <= 1024) ? ic.gn_w : 1024; // ipad pro 12.9 を考慮
  
  static gn_mgnLrg = 12; // margin large
  static gn_mgnNrm = 6; // margin normal
  static gn_mgnSml = 3; // margin small

//  static gn_mdlH = ic.gn_h - ic.gn_mgnNrm * 2;  
//  static gn_mdlW = ic.gn_bdyW - ic.gn_mgnNrm * 2;
//  static gn_mdlW = ((ic.gn_bdyW > 512 ) ? 512 : ic.gn_bdyW) - ic.gn_mgnNrm * 2;

  static gn_iconSizeLrg = 40; // ison size large
  static gn_iconSizeNrm = 30; // ison size normal
  static gn_iconSizeSml = 20; // ison size small

  static gn_bdrWFat = 4.8; // border width fat
  static gn_bdrWNrm = 2.4; // border width normal
  static gn_bdrWNrw = 1.2; // border width narrow

//  static gn_hdrBarH = (ic.g_app_type.indexOf('i') > 0) ? 30 : 0; // g_app_type が i を含む場合
//  static gn_ftrBarH = (ic.g_app_type.indexOf('i') > 0) ? 10 : 0; // g_app_type が i を含む場合

  static gn_hdrBarH = (ic.g_os == 'i' && ic.gn_h >= 800) ? 30 : 0; // g_app_type が i を含む場合
  static gn_ftrBarH = (ic.g_os == 'i' && ic.gn_h >= 800) ? 10 : 0; // g_app_type が i を含む場合

  static gn_hdrH = ic.gn_iconSizeLrg + ic.gn_mgnNrm * 2 + ic.gn_hdrBarH; // hdr height
  static gn_ftrH = ic.gn_iconSizeLrg + ic.gn_mgnNrm * 2 + ic.gn_ftrBarH; // ftr height

  static gn_bdyH = ic.gn_h - (ic.gn_hdrH + ic.gn_ftrH);

  static gn_hdrY = 0;
  static gn_bdyY = ic.gn_hdrH;
//  static gn_ftrY = ic.gn_hdrH + ic.gn_bdyH; // border は component の外側としてカウントされる

  static gn_btnWLrg = 120; // button width large
  static gn_btnWNrm = 90; // button width normal
  static gn_btnWSml = 60; // button width small

  static gn_chbW = 20; // checkbox width
  static gn_arwW = 30; // arrow width
  static gn_scbW = 16; // scroll bar width
      
  static gn_bdrRdsLrg = 12; // border radius large
  static gn_bdrRdsNrm = 6; // border radius normal
  static gn_bdrRdsSml = 3; // border radius small

  static gn_fontSizeLrg = 18; // font size large
  static gn_fontSizeNrm = 16; // font size normal
  static gn_fontSizeSml = 14; // font size small
  
  static gn_btnIconSize = ic.gn_fontSizeSml + ic.gn_mgnNrm * 2; // size of button icon
  
  // zIndex
  static gn_zIdxBdy  = 10; // for Bdy
  static gn_zIdxFtr  = 20; // for Ftr
  static gn_zIdxHdr  = 30; // for Hdr
  static gn_zIdxMdl  = 80; // for Mdl
  static gn_zIdxLdr  = 90; // for Ldr

  static g_fontCcdLrg = '#2d3142'; // font ccd large
  static g_fontCcdNrm = '#4d5162'; // font ccd normal
  static g_fontCcdSml = '#5d6172'; // font ccd small

  static g_ccdKN = '#222222'; // black normal
  static g_ccdKP = '#595857'; // black pale
  static g_ccdHN = '#80989b'; // glay
  static g_ccdHP = '#c0c6c9'; // glay
  static g_ccdBP = '#deb068'; // brown
  static g_ccdPP = '#f6bfbc'; // pink
  static g_ccdMP = '#dbd0e6'; // purple
  static g_ccdAN = '#007bbb'; // Blue
  static g_ccdAP = '#89c3eb'; // Blue
  static g_ccdCN = '#00acc1'; // cyan
  static g_ccdCP = '#a0d8ef'; // cyan
  static g_ccdGP = '#d0e8d2'; // green
  static g_ccdYP = '#f5e56b'; // yellow
  static g_ccdON = '#f39800'; // orange
  static g_ccdOP = '#f7b977'; // orange
  static g_ccdRN = '#c40000'; // red
  static g_ccdRP = '#f2a0a1'; // red
  static g_ccdWN = '#fffffc'; // white

  static gdd_ccdDefss = {
    own1:{
      hdrCcd: '#c40000',
      ftrCcd: '#c40000',
      bdyCcd: '#c40000',
    },
    own2:{
      hdrCcd: '#006400',
      ftrCcd: '#006400',
      bdyCcd: '#006400',
    },
    own3:{
      hdrCcd: '#707070',
      ftrCcd: '#707070',
      bdyCcd: '#707070',
    },
/*
    own4:{
      hdrCcd: '#007bbb',
      ftrCcd: '#007bbb',
      bdyCcd: '#007bbb',
    },
*/
    adm1:{
      hdrCcd: '#006400',
      ftrCcd: '#006400',
      bdyCcd: '#006400',
    },
    adm2:{
      hdrCcd: '#707070',
      ftrCcd: '#707070',
      bdyCcd: '#707070',
    },
/*
    adm3:{
      hdrCcd: '#007bbb',
      ftrCcd: '#007bbb',
      bdyCcd: '#007bbb',
    },
*/
    mmb1:{
      hdrCcd: '#707070',
      ftrCcd: '#707070',
      bdyCcd: '#707070',
    },
/*
    mmb2:{
      hdrCcd: '#007bbb',
      ftrCcd: '#007bbb',
      bdyCcd: '#007bbb',
    },
*/
    cmn:{
//      hdrCcd: '#007bbb',
//      ftrCcd: '#007bbb',
//      bdyCcd: '#007bbb',
      hdrCcd: '#707070',
      ftrCcd: '#707070',
      bdyCcd: '#707070',
    },
  };
  //
  static g_backCcd = ic.g_ccdWN;
  static g_baseCcd = '#f0f0f0';
  static g_bdrCcd = '#bbbbbb'; // border color code

  static g_iniPageRole = '';
  static g_iniPageName = 'cLgn';

  static gd_stss1 = { // persisted state variable, myRN_stt にも加える必要あり
    //
    sgc_cm10_key: '', // app user key
    sgc_cm10c210: '', // app user name
    sgc_cm10c410: '', // app user privilidge
    //
    sgc_user_key: '',
    sgc_user_img: '',
    sgc_eml: '',
    sgc_nmb: '',
    sgc_tkn: '',
    //
    sgc_pageRole: ic.g_iniPageRole,
    sgc_pageName: ic.g_iniPageName,
    sgcd_pagePntKeys: {
      cm10_key: '',
      cm20_key: '',
    },
    sgc_pageKey: '',
    sgc_pageMode: '', // show / new /edit
    sgc_pagePrc: '',
    sgcb_pageEdt: false,
    //
    sgcld_pageInfHstss: [], // page info history
    
    sgcn_tab: 1,
  };

//  static sgcn_adjY = ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrm * 2; // adjust keyboard slide

  static gd_stss2 = { // not persisted state variable
    //
    sgcb_showLdr: false, // loader
    //
//    sgcn_hdrY: ic.gn_hdrY, // header position y
    sgcn_bdyY: ic.gn_bdyY, // body position y
//    sgcn_btmY: 0, // body position y
//    sgcd_inpMsrs: {}, // current input measures y
    sgcd_msrs: {}, // current input measures y
//    sgcn_btmH: 0, // bottom height
    sgcn_btmDh: 0, // bottom height
//    sgcn_bdyY: 0, // body position y
//    sgcn_adjY: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrm * 2, // adjust keyboard slide
    sgcn_adjY: 0, // adjust keyboard slide
//    sgcn_csrY: 0, // cursor position y
    sgcd_kbds: {}, // keyboard position y
    sgcn_dy: 0, 
/*
    sgcdd_ptnss: { // positions adjustment 
      b_adj: false,
      n_hdrDy: 0,
      d_kbds: {}, // keyboard
      d_msrs: {}, // measure
      d_csrs: {}, // cursor
    }, // current keyboards
*/
    //
    sgcd_items: {}, // commonly used item hdr / bdy / btm / ftr 間で情報を共有するために使用
    //
    sgcd_mdls: { // 使用するパラメータを事前に定義しないとエラーが発生
      pck: { // mdlType
        b_showMdl: false,
//        ld_itemss: {},
//        ld_itemss: [],
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
      },
      file: { // mdlType
        b_showMdl: false,
        mode: 'text/csv',
        onRead: null, // callback on read
      },
      menu: { // mdlType
        b_showMdl: false,
        ld_iss: [{
          pfx:'',
          onPrs: null,
        }],
      },
      pckFiles: { // mdlType
        b_showMdl: false,
//        ld_itemss: {},
//        ld_itemss: [],
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
      },
      pckSch: { // mdlType
        b_showMdl: false,
//        ld_itemss: {},
//        ld_itemss: [],
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
      },
      cfm: {
        b_showMdl: false,
        msg: '',
        ld_btnss: [
          {
            pfx: '',
            o_onPrs: null,
          },
        ],
      }
    },
    //
    sgcd_schs: {
      b_showSch: false,
      word: '',
    }, // for search
    //
    sgcd_hdrs: {
      pfx: '',
      d_leftBtns: {
        b_vsb: false,
        iconName: null,
        pfx: null,
        onPrs: null,
      },
    },
    //
    sgcd_bdys: {
        ld_defss: [],
    },
    //
    sgcdld_cm31sss: null,
    //
//    sgcn_srl: 0,
//    sgcn_prs: 0, // progress
    sgcd_prss: { // progress
      b_vsb: false,
      n_crrCnt: 0,
      n_ttlCnt: 0,
      n_wgt: 100,
    }, // progress

    sgcd_dmns: { // dimensions
      n_w: ic.gn_w, 
      n_h: ic.gn_h,
      n_bdyW: ic.gn_bdyW,
      n_bdyH: ic.gn_bdyH,
    }, 
  }

  static gn_iniItemCnt = 10; // initial Item count

  static gn_logoH = 60; // ロゴサイズに合わせて調整
  static gn_logoW = 60; // ロゴサイズに合わせて調整

  static gb_setCm31 = true; // 部門運営者マスタを確認

  static gld_yesNo = [
    {
      key:'1',
      pfx:'はい'
    },
    {
      key:'0',
      pfx:'いいえ'
    },
  ];
}
